import axios from 'axios';
import { tokenKey } from './contant';

export const baseURL = process.env.REACT_APP_HH_ENDPOINT;

const token = sessionStorage.getItem(tokenKey) ?? '';

const axiosInstance = axios.create({
  baseURL: baseURL!,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

axiosInstance.interceptors.request.use(function (config: any) {
  const authToken = sessionStorage.getItem(tokenKey) ?? '';
  config.headers.Authorization = `Bearer ${authToken}`;

  return config;
});

export default axiosInstance;
